module.exports = __webpack_public_path__ + "static/media/permacool.342b9bbe.svg";